module.exports = __webpack_public_path__ + "static/media/electrical_services.8f0c3596.svg";